/* The Bannerman - "Get us licensed" petition popup.  [BUILD: v3-2026-08-02]
   Self-contained: injects its own styles + modal, no Liquid needed.
   Opened by exit-intent (desktop), a scroll-back-to-top proxy (mobile),
   or any element with [data-open-petition] or a link to #petition.
   Shows once per visitor. Signatures post to Shopify's /contact (emails the
   store contact email) and also subscribe the email. Load once, before </body>:
     <script src="{{ 'petition.js' | asset_url }}" defer></script>
*/
(function () {
  if (window.__bnrPet) return; window.__bnrPet = true;
  window.__bnrPetBuild = 'v15-dot-center';
  var KEY = 'bnrPetSeen';

  var css = ''
    + '.bnr-pet{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;padding:18px;font-family:var(--font-body-family,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif);}'
    + '.bnr-pet[hidden]{display:none;}'
    + '.bnr-pet *{box-sizing:border-box;}'
    + '.bnr-pet__overlay{position:absolute;inset:0;background:rgba(12,16,22,.55);}'
    + '.bnr-pet__box{position:relative;width:100%;max-width:470px;background:#fff;color:#14181f;border-radius:26px;box-shadow:0 30px 70px rgba(0,0,0,.35);padding:30px 30px 26px;animation:bnrPop .25s ease;max-height:92vh;overflow:auto;}'
    + '@keyframes bnrPop{from{transform:translateY(14px) scale(.97);opacity:0}to{transform:none;opacity:1}}'
    + '.bnr-pet__x{position:absolute;top:14px;right:16px;border:0;background:none;font-size:24px;line-height:1;color:#9aa3af;cursor:pointer;}'
    + '.bnr-pet__eyebrow{font-size:12px;font-weight:800;letter-spacing:.16em;color:#1d4ed8;text-transform:uppercase;}'
    + '.bnr-pet__h{font-size:24px;line-height:1.2;margin:8px 0 10px;font-weight:800;}'
    + '.bnr-pet__sub{font-size:14.5px;line-height:1.5;color:#5b6572;margin:0 0 18px;}'
    + '.bnr-pet__hide{display:none !important;}'
    + '.bnr-pet__form{margin:0;}'
    + '.bnr-pet__lhead{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:9px;}'
    + '.bnr-pet__llbl{font-size:12.5px;font-weight:700;letter-spacing:.02em;color:#39424f;text-transform:uppercase;}'
    + '.bnr-pet__toggle{border:0;background:none;color:#1d4ed8;font-size:13px;font-weight:600;cursor:pointer;padding:0;}'
    + '.bnr-pet__grid{display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-bottom:8px;}'
    + '.bnr-pet__chip{display:flex;align-items:center;gap:9px;border:1.5px solid #e5e8ec;border-radius:13px;padding:10px 12px;cursor:pointer;font-size:14px;font-weight:600;-webkit-user-select:none;user-select:none;}'
    + '.bnr-pet__chip input{-webkit-appearance:none;appearance:none;width:18px;height:18px;border:1.5px solid #c4cad3;border-radius:6px;display:grid;place-content:center;cursor:pointer;flex:0 0 auto;margin:0;}'
    + '.bnr-pet__chip input:checked{background:#1d4ed8;border-color:#1d4ed8;}'
    + '.bnr-pet__chip input:checked::after{content:"";width:5px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg);margin-top:-2px;}'
    + '.bnr-pet__chip.on{border-color:#1d4ed8;background:#dbe7fb;}'
    + '.bnr-pet__other{display:flex;align-items:center;gap:9px;border:1.5px dashed #cfd5dd;border-radius:13px;padding:8px 12px;margin-bottom:14px;}'
    + '.bnr-pet__other span{font-size:13px;color:#5b6572;white-space:nowrap;}'
    + '.bnr-pet__other input{border:0;outline:0;font-size:14px;width:100%;background:none;color:inherit;}'
    + '.bnr-pet__in{width:100%;border:1.5px solid #e5e8ec;border-radius:13px;padding:12px 14px;font-size:14.5px;outline:0;margin-bottom:11px;color:inherit;background:#fff;}'
    + '.bnr-pet__in:focus{border-color:#1d4ed8;}'
    + '.bnr-pet__btn{width:100%;border:0;background:#1d4ed8;color:#fff;font-size:16px;font-weight:700;padding:14px;border-radius:14px;cursor:pointer;margin-top:5px;}'
    + '.bnr-pet__btn:hover{background:#1743b8;}'
    + '.bnr-pet__fine{font-size:11.5px;color:#9aa3af;text-align:center;margin:11px 0 0;line-height:1.4;}'
    + '.bnr-pet-linkbar{text-align:center;padding:18px 16px;font-family:var(--font-body-family,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif);}'
    + '.bnr-pet-link{display:inline-block;font-size:13.5px;font-weight:600;color:#1d4ed8;text-decoration:underline;text-underline-offset:3px;cursor:pointer;background:none;border:0;}'
    + '.bnr-pet-link:hover{color:#1743b8;}'
    + '.bnr-pet__logo{display:block;height:54px;width:auto;margin:2px auto 12px;border-radius:10px;}'
    + '.bnr-pet-badge{background:#c9a24b !important;color:#15181d !important;font-family:"BC Sans",sans-serif !important;font-weight:800 !important;text-transform:uppercase !important;letter-spacing:.6px !important;font-size:12px !important;line-height:1 !important;text-align:center !important;height:32px !important;min-height:32px !important;max-height:32px !important;border:0 !important;width:186px !important;padding:0 12px !important;border-radius:6px !important;text-decoration:none !important;box-sizing:border-box !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;gap:6px !important;white-space:nowrap !important;cursor:pointer !important;border:0 !important;}'
    + '.bnr-pet-badge:hover{background:#d8b45f !important;color:#15181d !important;}'
    + '.bnr-pet-badge .bnr-pet-badge-ico{font-size:13px;line-height:1;margin:0 !important;flex:0 0 auto;}'
    + '.bnr-pet-badge-li{display:flex;align-items:center;list-style:none;margin:0 0 0 6px;}'
    + 'ul.mobile-menu .bnr-pet-badge-li{margin:8px 0 8px 0;}'
    + '.bnr-pet-badge-fixed{position:fixed;top:12px;right:150px;z-index:99999;}';

  var chips = ['NHL', 'NBA', 'MLB', 'NFL', 'MLS', 'CFL', 'NCAA'].map(function (l) {
    return '<label class="bnr-pet__chip on"><input type="checkbox" value="' + l + '" checked> ' + l + '</label>';
  }).join('');

  var html = ''
    + '<div class="bnr-pet__overlay" data-pet-close></div>'
    + '<div class="bnr-pet__box" role="dialog" aria-modal="true" aria-label="Sign the licensing petition">'
    +   '<button class="bnr-pet__x" type="button" data-pet-close aria-label="Close">&times;</button>'
    +   '<div data-pet-view="form">'
    +     '<img class="bnr-pet__logo" src="https://thebannerman.ca/cdn/shop/files/Logo_Watermark.png" alt="The Bannerman" width="80" height="54">'
    +     '<div class="bnr-pet__eyebrow">Make it official</div>'
    +     '<h2 class="bnr-pet__h">Want officially-licensed prints of your team?</h2>'
    +     '<p class="bnr-pet__sub">We make retro canvas art for die-hard fans. To use real team logos and marks, the leagues have to license us &mdash; and they only say yes when they see the demand. Add your name and pick the leagues you want us to bring officially to The Bannerman.</p>'
    +     '<div class="bnr-pet__form" id="bnr-pet-form">'
    +       '<div class="bnr-pet__lhead"><span class="bnr-pet__llbl">Which leagues?</span>'
    +         '<button type="button" class="bnr-pet__toggle" id="bnr-pet-toggle">Select none</button></div>'
    +       '<div class="bnr-pet__grid" id="bnr-pet-grid">' + chips + '</div>'
    +       '<input class="bnr-pet__in" type="text" id="bnr-pet-name" placeholder="Your name (optional)">'
    +       '<input class="bnr-pet__in" type="email" id="bnr-pet-email" placeholder="Email address" required>'
    +       '<button class="bnr-pet__btn" type="button" id="bnr-pet-submit">Add my name</button>'
    +       '<p class="bnr-pet__fine">We&#39;ll only email you about licensing progress &mdash; no spam, unsubscribe anytime.</p>'
    +     '</div>'
    +   '</div>'
    +   '<div class="bnr-pet__hide" data-pet-view="thanks">'
    +     '<div class="bnr-pet__eyebrow">Thank you</div>'
    +     '<h2 class="bnr-pet__h">You&#39;re on the list.</h2>'
    +     '<p class="bnr-pet__sub">Every name gets us closer. We&#39;ll email you the moment there&#39;s licensing news &mdash; and in the meantime, keep an eye on the shop.</p>'
    +     '<button class="bnr-pet__btn" type="button" data-pet-close>Close</button>'
    +   '</div>'
    + '</div>';

  function init() {
    var style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);
    var root = document.createElement('div'); root.className = 'bnr-pet'; root.id = 'bnr-pet'; root.hidden = true; root.innerHTML = html;
    document.body.appendChild(root);

    var grid = root.querySelector('#bnr-pet-grid');
    var toggle = root.querySelector('#bnr-pet-toggle');
    var submitBtn = root.querySelector('#bnr-pet-submit');
    var emailInput = root.querySelector('#bnr-pet-email');

    function seen() { try { return localStorage.getItem(KEY) === '1' || document.cookie.indexOf(KEY + '=1') > -1; } catch (e) { return document.cookie.indexOf(KEY + '=1') > -1; } }
    function markSeen() { try { localStorage.setItem(KEY, '1'); } catch (e) {} var d = new Date(); d.setFullYear(d.getFullYear() + 1); document.cookie = KEY + '=1; path=/; expires=' + d.toUTCString(); }
    function open() { root.hidden = false; markSeen(); }
    function close() { root.hidden = true; }

    function sync() {
      var any = false;
      grid.querySelectorAll('.bnr-pet__chip').forEach(function (c) { var on = c.querySelector('input').checked; c.classList.toggle('on', on); if (on) any = true; });
      toggle.textContent = any ? 'Select none' : 'Select all';
    }
    grid.addEventListener('change', sync);
    toggle.addEventListener('click', function () {
      var on = toggle.textContent === 'Select all';
      grid.querySelectorAll('input').forEach(function (i) { i.checked = on; });
      sync();
    });

    root.querySelectorAll('[data-pet-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-open-petition], a[href$="#petition"]');
      if (t) { e.preventDefault(); open(); }
    });
    if (location.hash === '#petition') open();

    // Gold "Sign the Petition" badge in the site header (matches the red "On TV
    // Today" badge). Clicking it opens this popup via the [data-open-petition] hook.
    function injectPetBadge() {
      function make() {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bnr-pet-badge';
        b.setAttribute('data-open-petition', '');
        b.setAttribute('aria-label', 'Sign the petition');
        b.innerHTML = '<span class="bnr-pet-badge-ico">✍</span>Sign the Petition';
        return b;
      }
      // Pinnacle theme: real nav lists are ul.thb-full-menu (desktop, holds
      // Contact) and ul.mobile-menu (inside the hamburger drawer). Add the badge
      // to each so it sits inline next to Contact AND inside the mobile menu.
      var menus = document.querySelectorAll('ul.thb-full-menu, ul.mobile-menu');
      if (menus.length) {
        menus.forEach(function (ul) {
          if (ul.querySelector('.bnr-pet-badge-li')) return;   // this menu already has it
          var li = document.createElement('li'); li.className = 'bnr-pet-badge-li'; li.appendChild(make()); ul.appendChild(li);
        });
        return;
      }
      // fallback selectors for other themes
      var sels = ['.header__inline-menu > ul', 'nav[role="navigation"] ul',
                  'header nav ul', '.list-menu--inline', '.site-nav__list', 'header ul'];
      for (var i = 0; i < sels.length; i++) {
        var ul = document.querySelector(sels[i]);
        if (ul && !ul.querySelector('.bnr-pet-badge-li')) { var li2 = document.createElement('li'); li2.className = 'bnr-pet-badge-li'; li2.appendChild(make()); ul.appendChild(li2); return; }
      }
      if (document.querySelector('.bnr-pet-badge')) return;
      var f = make(); f.className = 'bnr-pet-badge bnr-pet-badge-fixed'; document.body.appendChild(f);
    }
    injectPetBadge();
    setTimeout(injectPetBadge, 1200);
    setTimeout(injectPetBadge, 3500);

    if (!seen()) {
      // let visitors browse for a bit before we ever offer the popup on exit
      var armed = false;
      setTimeout(function () { armed = true; }, 20000); // ~20s of browsing first
      document.addEventListener('mouseout', function (e) { if (armed && !e.relatedTarget && e.clientY <= 0 && !seen()) open(); });
      var deep = false;
      window.addEventListener('scroll', function () {
        var y = window.pageYOffset, h = document.body.scrollHeight - window.innerHeight;
        if (h > 0 && y / h > 0.5) deep = true;
        if (armed && deep && y < 120 && !seen()) open();
      }, { passive: true });
    }

    // No <form> element on purpose: everything goes through JS, so the browser
    // can never natively submit and redirect the page. "Add my name" is a button.
    function showThanks() {
      root.querySelector('[data-pet-view="form"]').classList.add('bnr-pet__hide');
      root.querySelector('[data-pet-view="thanks"]').classList.remove('bnr-pet__hide');
    }
    function submitPetition() {
      var email = (emailInput.value || '').trim();
      if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
        emailInput.style.borderColor = '#dc2626';
        emailInput.focus();
        return;
      }
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding your name...'; }
      var picked = [];
      grid.querySelectorAll('input:checked').forEach(function (i) { picked.push(i.value); });
      var name = (root.querySelector('#bnr-pet-name').value || '').trim();

      var fd = new FormData();
      fd.append('form_type', 'contact');
      fd.append('utf8', '✓');
      fd.append('contact[Petition]', 'Wants The Bannerman officially licensed');
      fd.append('contact[Leagues]', picked.join(', '));
      if (name) fd.append('contact[Name]', name);
      fd.append('contact[email]', email);
      fd.append('contact[body]', 'Petition signature');

      fetch('/contact', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .catch(function () {})
        .finally(function () {
          // also add them to the email list
          var s = new FormData();
          s.append('form_type', 'customer'); s.append('utf8', '✓');
          s.append('contact[email]', email); s.append('contact[tags]', 'petition');
          fetch('/contact', { method: 'POST', body: s }).catch(function () {});
          showThanks();
        });
    }
    if (submitBtn) { submitBtn.addEventListener('click', submitPetition); }
    // let Enter in the email box submit too
    if (emailInput) { emailInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submitPetition(); } }); }
  }

  if (document.body) init();
  else document.addEventListener('DOMContentLoaded', init);
})();
